import {canBePickedUp, getIdAndNameFromCategory, transformProductsToItems} from "../libraries/utils";
import * as mutationTypes from "../store/mutation-types";
import appConfig from "../appconfig";
import {generateDifferentiatedGroups} from "../helper/ProductSelectionHelper";
import routeMapper from "../router/routeMapper";
import {goToConfigurationStep} from "../helper/ProductConfigurationRedirectionHelper";

export default {
	methods: {
		shouldActivateUpgradeToMenu(dealSelection) {
			const baseProduct = this.productCatalog.getProduct(dealSelection.productId);
			// skip if upgrade to is not set up
			const deals = baseProduct.options.deals;
			if(!deals || !deals.upgradeToProductId || !deals.triggerUpgradeToMenuItems || !deals.triggerUpgradeToMenuItems.length) return false;
			const relatedMenu = this.productCatalog.getProduct(deals.upgradeToProductId);
			// we should not offer upgrade if menu is disabled in the shop
			if(!canBePickedUp(
				relatedMenu,
				this.productCatalog,
				this.cachedPickupRules,
				this.globalSelectedShop.id
			)) return false;
			// check if any of trigger products are added to the cart / or proceed
			const productToMergeWithSelection = this.selections.find(selection => {
				return deals.triggerUpgradeToMenuItems.includes(selection.productId);
			});
			if(!productToMergeWithSelection) return false;
			const triggerProduct = this.productCatalog.getProduct(productToMergeWithSelection.productId);
			const [dealItem, menuItem, triggerItem] = transformProductsToItems(
				[baseProduct, relatedMenu, triggerProduct],
				this.productCatalog,
				this,
				this.$store.getters.tenantSpecificData.deliveryChoice
			);
			const priceDifference = this.discountPrice(dealItem) + this.discountPrice(triggerItem)
				- this.discountPrice(menuItem);
			if(priceDifference <= 0) {
				return false;
			}
			const upgradeToItemName = relatedMenu.name;
			this.upgradeToMenuData = {
				productToMergeWithSelection,
				relatedMenu,
				dealSelection,
				baseProduct,
				priceDifference,
				upgradeToItemName,
				menuItem
			};
			return true;
		},
		upgradeDealToMenu() {
			if(!this.upgradeToMenuData) {
				// there was some error, upgrade not available
				// TODO: discuss how to handle this case
				return;
			}
			const productToMergeWithSelection = this.upgradeToMenuData.productToMergeWithSelection;
			const dealSelection = this.upgradeToMenuData.dealSelection;
			// remove deal from cart
			this.$store.dispatch(mutationTypes.REMOVE_FROM_CART_BY_PRODUCT_SELECTION_ID, dealSelection.productSelectionId);
			// remove or decrease quantity from the trigger product
			if (productToMergeWithSelection.quantity === 1) {
				this.$store.dispatch(
					mutationTypes.REMOVE_FROM_CART_BY_PRODUCT_SELECTION_ID,
					productToMergeWithSelection.productSelectionId
				);
			} else {
				this.$store.dispatch(mutationTypes.UPDATE_CART_QUANTITY_BY_ID, {
					productSelectionId: productToMergeWithSelection.productSelectionId,
					quantity: productToMergeWithSelection.quantity - 1
				});
			}
			this.$store.commit(mutationTypes.SET_SELECTED_DEAL_ID);
			const firstCategoryId = this.$store.getters.productCatalog.getCategories()[0].extId;
			if(["mobileBrowser", "mobileApp"].includes(appConfig.channelAlias())) {
				this.$router.push(`/category/${firstCategoryId}?dealRelatedMenuId=${this.upgradeToMenuData.relatedMenu.id}`);
			} else {
				const menuItem = this.upgradeToMenuData.menuItem;
				if(!menuItem) {
					return;
				}
				this.$router.push({
					name: routeMapper.routeNames.defaultProductCatalog,
					params: {
						categoryId: firstCategoryId
					}
				});
				generateDifferentiatedGroups(menuItem.product);
				const newProductSelection = this.createCompositeSelectedProducts(menuItem);
				menuItem.productSelections = this.findOrCreateProductSelection(menuItem.product.id)
					.concat({
						...newProductSelection,
						category: getIdAndNameFromCategory(this.productCatalog.getDepartment(menuItem.product.departmentId))
					});
				setTimeout(() => {
					goToConfigurationStep(this, {
						item: menuItem,
						baseProductId: this.upgradeToMenuData.relatedMenu.id
					});
				});
			}
			this.pushGTMInternal(
				"deal_upgrade_to_menu_selected",
				"Shopping cart",
				this.$route.path,
				"",
				{
					email: (this.$store.getters.personData || {}).email,
					selectedRestaurant: (this.$store.getters.globalSelectedShop || {}).shopName
				}
			);
			this.showUpgradeDealToMenuDialog = false;
		}
	}
};
